import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { MERCADO_PAGO } from '../../constants/mediosEnviosPagos.js'
import { formatearFecha, formatearMoneda } from '../helpers/helper'
import Precios from '../reutilizables/precios/Precios'
import { buscarMedioPago } from '../servicios/publicacionesService'
import styles from './DetallePago.module.css'

const DetallePago = (props) => {
  const { pedidoItem, fechaPedido, esVentas } = props
  const [medioPago, setMedioPago] = useState({})

  const recibirMediosPago = async () => {
    const { data } = await buscarMedioPago()
    setMedioPago(data.find((m) => m.idMedioPago === pedidoItem.idMedioPago))
  }

  useEffect(() => {
    if (Object.keys(medioPago).length === 0 && pedidoItem) {
      recibirMediosPago()
    }
  }, [])

  return (
    <>
      <div className={styles.contenedor}>
        <h3 className={styles.titulo}>Detalle de Pago</h3>
        <div className={styles.tarjeta}>
          <div className={styles.grilla}>
            <p className={styles.campo}>
              <i className={`fa fa-user fa-fw ${styles.icono}`} aria-hidden="true" />
              <span>
                <strong>Comprador:</strong> {pedidoItem.compradorNombre}
              </span>
            </p>

            <p className={styles.campo}>
              <i className={`fa fa-calendar-o fa-fw ${styles.icono}`} aria-hidden="true" />
              <span>
                <strong>Fecha de Pedido:</strong> {formatearFecha(fechaPedido, 'F')}
              </span>
            </p>

            {!esVentas && (
              <div className={`${styles.campo} ${styles.campoAncho}`}>
                <i className={`fa fa-info-circle fa-fw ${styles.icono}`} aria-hidden="true" />
                <span className={styles.detalleMaterial}>
                  <p className={styles.detalleCampo}>
                    <strong>Código de material: </strong>
                    {pedidoItem.codMat?.trim() || 'No especificado'}
                  </p>
                  <p className={styles.detalleCampo}>
                    <strong>Descripción Material: </strong>
                    {pedidoItem.descripcionMat || 'No especificado'}
                  </p>
                  <p className={styles.detalleCampo}>
                    <strong>Planta: </strong>
                    {pedidoItem.valorPlantaDesc || 'No especificada'}
                  </p>
                  <p className={styles.detalleCampo}>
                    <strong>Tipo de imputación: </strong>
                    {pedidoItem.imputacionTipo || 'No especificada'}
                  </p>
                  <p className={styles.detalleCampo}>
                    <strong>{pedidoItem.imputacionTipo || 'Imputación'}: </strong>
                    {pedidoItem.imputacionTipoOpcionDesc || 'No especificada'}
                  </p>
                </span>
              </div>
            )}
            <p className={styles.campo}>
              <i
                className={`${medioPago?.icono || 'fa fa-credit-card'} fa-fw ${styles.icono}`}
                aria-hidden="true"
              />
              <span>
                <strong>Medio de Pago: </strong>
                {pedidoItem.tipoPagoMP &&
                  pedidoItem.idMedioPago === MERCADO_PAGO &&
                  `${pedidoItem.tipoPagoMP} mediante `}
                {medioPago?.nombre || ''}
              </span>
            </p>

            <p className={styles.campo}>
              <i className={`fa fa-truck fa-fw ${styles.icono}`} aria-hidden="true" />
              <span>
                <strong>Medio de Envío: </strong>
                {pedidoItem.envioTipo || ''}
              </span>
            </p>

            {Boolean(pedidoItem.entregaLocalidadDesc) && pedidoItem.entregaLocalidadDesc !== '' && (
              <p className={`${styles.campo} ${styles.campoAncho}`}>
                <i className={`fa fa-home fa-fw ${styles.icono}`} aria-hidden="true" />
                <span>
                  <strong>Domicilio de entrega: </strong>
                  {pedidoItem.entregaCalle}, {pedidoItem.entregaCalleAltura},{' '}
                  {pedidoItem.entregaLocalidadDesc}
                </span>
              </p>
            )}
            <div className={`${styles.campo} ${styles.campoAncho} ${styles.precios}`}>
              <div className={styles.precioTotal}>
                <i className={`fa fa-shopping-cart fa-fw ${styles.icono}`} aria-hidden="true" />
                <Precios
                  nombre="Total producto"
                  precio={pedidoItem.precioUnitario}
                  monedaSimbolo={formatearMoneda(pedidoItem.monedaSimbolo)}
                  alicuota={pedidoItem.alicuota}
                  cantidad={pedidoItem.cantidad || 1}
                  mostrarCantidad
                  showSinIVA={true}
                />
              </div>
              {pedidoItem.envioTipo && pedidoItem.precioEnvio > 0 && (
                <div className={styles.precioEnvio}>
                  <i className={`fa fa-truck fa-fw ${styles.icono}`} aria-hidden="true" />
                  <Precios
                    nombre={pedidoItem.envioTipo}
                    precio={pedidoItem.precioEnvio}
                    monedaSimbolo={formatearMoneda(pedidoItem.monedaSimbolo)}
                    alicuota={21}
                    showSinIVA={true}
                  />
                </div>
              )}
            </div>

            {pedidoItem.numComprobantePago && (
              <p className={`${styles.campo} ${styles.campoAncho}`}>
                <i className={`fa fa-file-text-o fa-fw ${styles.icono}`} aria-hidden="true" />
                <span>
                  <strong>Número de comprobante: </strong> {pedidoItem.numComprobantePago}
                </span>
              </p>
            )}
          </div>
        </div>
      </div>
      <hr />
    </>
  )
}

DetallePago.propTypes = {
  pedidoItem: PropTypes.shape({
    idMedioPago: PropTypes.number.isRequired,
    compradorNombre: PropTypes.string.isRequired,
    monedaSimbolo: PropTypes.string.isRequired,
    precioUnitario: PropTypes.number.isRequired,
    precioEnvio: PropTypes.number,
    numComprobantePago: PropTypes.string.isRequired,
    entregaLocalidad: PropTypes.string,
    entregaCalle: PropTypes.string,
    entregaCalleAltura: PropTypes.string,
    entregaProvincia: PropTypes.string,
    idMedioEnvio: PropTypes.number.isRequired,
    envioTipo: PropTypes.string.isRequired,
    cantidad: PropTypes.number.isRequired,
    alicuota: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    tipoPagoMP: PropTypes.string,
    entregaLocalidadDesc: PropTypes.string,
    valorPlantaDesc: PropTypes.string,
    imputacionTipo: PropTypes.string,
    imputacionTipoOpcionDesc: PropTypes.string,
    descripcionMat: PropTypes.string,
    codMat: PropTypes.string,
    anticipo: PropTypes.number.isRequired
  }).isRequired,
  fechaPedido: PropTypes.string.isRequired,
  esVentas: PropTypes.bool.isRequired
}

export default DetallePago
